import { FC, useState, useEffect } from 'react';

interface Props {
    title: string;
    onClose: () => void;
    onSaveOnly: () => void;
    onSaveAndDownload: () => void;
}

const checkIsPwaInstalled = (): boolean => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia('(display-mode: standalone)').matches ||
           window.matchMedia('(display-mode: fullscreen)').matches ||
           window.matchMedia('(display-mode: minimal-ui)').matches ||
           (navigator as any).standalone === true;
};

export const DownloadConfirmModal: FC<Props> = ({ title, onClose, onSaveOnly, onSaveAndDownload }) => {
    const [isPwa, setIsPwa] = useState(false);

    useEffect(() => {
        setIsPwa(checkIsPwaInstalled());
    }, []);

    return (
        <div style={{
            position: 'fixed', inset: 0, zIndex: 1000,
            background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(2px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '20px'
        }} onClick={onClose}>
            <div style={{
                background: 'var(--surface-color)', padding: '25px', borderRadius: '12px',
                width: '100%', maxWidth: '350px',
                border: '1px solid var(--border-color)',
                boxShadow: '0 10px 40px rgba(0,0,0,0.5)'
            }} onClick={e => e.stopPropagation()}>

                <h3 style={{ margin: '0 0 10px 0', fontSize: '1.2rem' }}>Save to Library</h3>
                <p style={{ margin: '0 0 20px 0', color: 'var(--text-secondary)', lineHeight: 1.4 }}>
                    "{title}" is a Narrated Book Club title. Would you like to download the audio now for offline listening?
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <button 
                        onClick={isPwa ? onSaveAndDownload : undefined} 
                        disabled={!isPwa}
                        style={{
                            padding: '14px', borderRadius: '8px', border: 'none',
                            background: isPwa ? '#673AB7' : 'var(--text-disabled)',
                            color: isPwa ? 'white' : 'var(--text-muted)',
                            fontWeight: 600,
                            cursor: isPwa ? 'pointer' : 'not-allowed',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                            fontSize: '1rem',
                            opacity: isPwa ? 1 : 0.6
                        }}
                    >
                        <span>⬇️</span> Save & Download Audio
                    </button>

                    {!isPwa && (
                        <p style={{ margin: '5px 0', fontSize: '0.85rem', color: '#ff9800', lineHeight: 1.4, textAlign: 'center', fontWeight: '500' }}>
                            ⚠️ Install the app to enable reliable airplane-mode downloads.
                        </p>
                    )}

                    <button onClick={onSaveOnly} style={{
                        padding: '14px', borderRadius: '8px', border: '1px solid var(--border-color)',
                        background: 'transparent', color: 'var(--text-color)',
                        cursor: 'pointer', fontSize: '1rem'
                    }}>
                        Save Text Only
                    </button>

                    <button onClick={onClose} style={{
                        padding: '10px', marginTop: '5px',
                        background: 'transparent', border: 'none',
                        color: 'var(--text-secondary)', cursor: 'pointer',
                        fontSize: '0.9rem'
                    }}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};
